// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subMenuOverride > ul.ant-menu-sub {\n  border-radius: 0;\n  box-shadow: none;\n  max-height: 100vh;\n}\nheader-app-root li.ant-menu-item:after {\n  border: none !important;\n}\nspan > span.ant-avatar-string {\n  color: #f7e9e8;\n}\n", ""]);
// Exports
module.exports = exports;
